// ContactSectionBinder.jsx
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import JsonService from "./JsonService";

export default function ContactSectionBinder({
  content_url = "/sections/contact.json",
  className = "",
  style = {}
}) {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    const ctrl = new AbortController();
    (async () => {
      try {
        const j = await JsonService.fetchJson({
          url: content_url,
          signal: ctrl.signal,
          cache: "no-store"
        });

        if (j?.render_control_type === "contact_section") {
          setCfg({
            hero: j.hero || null,
            faqs: Array.isArray(j.faqs) ? j.faqs : []
          });
        } else {
          console.warn("ContactSectionBinder: unexpected JSON shape at", content_url, j);
          setCfg(null);
        }
      } catch (e) {
        console.warn("ContactSectionBinder load failed:", e);
        setCfg(null);
      }
    })();
    return () => ctrl.abort();
  }, [content_url]);

  if (!cfg) return null;

  const { hero, faqs } = cfg;

  return (
    <Container className={className} style={style}>
      {hero && (
        <Row className="mt-4 mb-4">
          <Col md={12}>
            <h1 className="display-5 mb-3">
              {hero.title}
            </h1>
            {hero.subtitle && (
              <p className="lead">
                {hero.subtitle}
              </p>
            )}
            {hero.cta && hero.cta.href && (
              <Button
                as="a"
                href={hero.cta.href}
                target="_blank"
                rel="noopener noreferrer"
                variant="primary"
                className="mt-3"
              >
                {hero.cta.label || "Book a consult"}
              </Button>
            )}
          </Col>
        </Row>
      )}

      {faqs && faqs.length > 0 && (
        <Row className="mb-5">
          <Col md={10}>
            <h2 className="h4 mb-3">Frequently requested projects</h2>
            <Accordion alwaysOpen>
              {faqs.map((item, idx) => (
                <Accordion.Item eventKey={String(idx)} key={item.id || idx}>
                  <Accordion.Header>{item.question}</Accordion.Header>
                  <Accordion.Body>{item.answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      )}
    </Container>
  );
}
